"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function throttle(func, waitTime) {
  var timeout = null;
  var previous = 0;

  var later = function later() {
    previous = Date.now();
    timeout = null;
    func.apply(void 0, arguments);
  };

  return function () {
    var now = Date.now();
    var remaining = waitTime - (now - previous);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (remaining <= 0 || remaining > waitTime) {
      if (timeout) {
        clearTimeout(timeout);
      }

      later.apply(void 0, args);
    } else if (!timeout) {
      timeout = setTimeout.apply(void 0, [later, remaining].concat(args));
    }
  };
}

exports.throttle = throttle;
;